module.exports = __webpack_public_path__ + "img/snap_04.4a43729d.png";